// extracted by mini-css-extract-plugin
module.exports = {"mark":"LocationMarker_mark__1lHdJ","markerLabel":"LocationMarker_markerLabel__KShNw"};